import Packlink from '@sdk';
import { ServiceAllParams, IParcel, Service, IShipment, Shipment, ServiceRepository } from '@packlink/packlink-sdk';
import { first } from 'lodash';

export type ServiceFlags = Record<
    'customsRequired' | 'hasDropoffOrigin' | 'hasDropoffDestination' | 'hasOwnContract' | 'hasPrintInStore',
    boolean
>;

export class ServiceUtils {
    static getServiceParams(shipment: Shipment<IShipment>): ServiceAllParams {
        const params: ServiceAllParams = {
            source: shipment.source,
            from: {
                country: shipment.from?.alpha2Code as string,
                zip: shipment.from?.zipCode as string,
            },
            to: {
                country: shipment.to?.alpha2Code as string,
                zip: shipment.to?.zipCode as string,
            },
            packages: shipment.parcels?.map((parcel) => parcel.toJSON()) as IParcel[],
            service_id: shipment.service?.id,
        };

        return params;
    }

    static getService(shipment: Shipment<IShipment>): Promise<Service | undefined> {
        const serviceRepository = new ServiceRepository(Packlink.apiClient);
        const params = this.getServiceParams(shipment);
        return serviceRepository.getServicesForSpecificSearch(params).then((services) => first(services));
    }

    static getCarrierLogo(logoId: string, cdnUrl: string = config.cdn.url): string {
        return `${cdnUrl}/apps/carrier-logos/${logoId}.svg`;
    }
}
